/** Encodes pinned version / label / latest for shared-session share dialogs (prompt + skill). */

export const LATEST_VALUE = "latest";
export const VERSION_PREFIX = "version:";
export const LABEL_PREFIX = "label:";

export type PinnedVersionSelection =
  | { type: "latest" }
  | { type: "version"; versionNumber: number }
  | { type: "label"; labelName: string };

export const encodePinnedVersionSelection = (selection: PinnedVersionSelection): string => {
  switch (selection.type) {
    case "latest":
      return LATEST_VALUE;
    case "version":
      return `${VERSION_PREFIX}${selection.versionNumber}`;
    case "label":
      return `${LABEL_PREFIX}${selection.labelName}`;
    default:
      return LATEST_VALUE;
  }
};

export const decodePinnedVersionSelection = (value: string): PinnedVersionSelection => {
  if (value === LATEST_VALUE) {
    return { type: "latest" };
  }
  if (value.startsWith(LABEL_PREFIX)) {
    return {
      type: "label",
      labelName: value.slice(LABEL_PREFIX.length),
    };
  }
  if (value.startsWith(VERSION_PREFIX)) {
    return {
      type: "version",
      versionNumber: Number(value.slice(VERSION_PREFIX.length)),
    };
  }
  return { type: "latest" };
};
